<template>
  <el-card class="h-full relative">
    <div class="h-full flex flex-col" v-if="!isSHowPaper">
      <div class="flex justify-between items-center">
        <div class="border-l-3 border-color-primary pl-10px text-18px">查看</div>
      </div>
      <div class="h-180px flex justify-around">
        <div class="flex-1 flex flex-col items-center justify-between cursor-pointer" @click="showJoinExamDialog">
          <img src="@/assets/images/education/person.png" alt="" class="mt-20px" />
          <p>考试人数:&nbsp;{{ examNum }}人</p>
        </div>
        <div class="flex-1 flex flex-col items-center justify-between">
          <v-chart v-loading="typeLoading" :options="joinOption" autoresize :theme="currentTheme"
            class="w-full h-full"></v-chart>
          <p>参加情况</p>
        </div>
        <div class="flex-1 flex flex-col items-center justify-between">
          <el-progress class="mt-10px" type="circle" :percentage="percentage"></el-progress>
          <p>通过率:&nbsp;{{ percentage }}%</p>
        </div>
        <!-- <div class="flex-1 flex flex-col items-center justify-between">
          <v-chart v-loading="typeLoading" :options="gradeOption" autoresize :theme="currentTheme"
            class="w-full  flex-1"></v-chart>
          <p>成绩分布</p>
        </div> -->
      </div>
      <div class="flex-1 mt-25px border-t pt-25px">
        <div class="flex mb-20px mr-10px">
          <el-input size="small" class="mr-10px !w-50" placeholder="考生姓名" maxlength="50"
            v-model="searchData.ExamineeName" clearable></el-input>
          <el-select v-model="searchData.DeptId" size="small" :placeholder="`${$t('所属部门')}`"
            class="mr-10px !w-50" clearable filterable>
            <el-option v-for="(item, index) in departmentList" :key="index" :label="item.displayName"
              :value="item.id"></el-option>
          </el-select>
          <el-select v-model="searchData.IsPass" size="small" :placeholder="`${$t('是否通过')}`" class="mr-10px !w-50"
            clearable>
            <el-option v-for="(item, index) in passList" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
          <el-button size="small" type="primary" @click="searchList">搜索</el-button>
          <el-button size="small" type="primary" @click="downloadGrades">下载成绩单</el-button>
        </div>
        <el-table :data="studentList" border class="w-full" stripe v-loading="loading"
          @selection-change="selectionChange" height="calc(100vh - 580px)">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="考生姓名" prop="ExamineeName" show-overflow-tooltip></el-table-column>
          <el-table-column label="所属部门" prop="DeptName" show-overflow-tooltip></el-table-column>
          <el-table-column label="得分" prop="Score" show-overflow-tooltip></el-table-column>
          <el-table-column label="是否通过" prop="IsPass" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.IsPass ? '是' : '否' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button size="mini" @click="viewInfo(scope.row)" :loading="loadPaper">查看试卷</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-60px flex items-center justify-end px-20px border-t">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableParams.pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="tableParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableParams.total">
          </el-pagination>
        </div>
      </div>
      <div class="flex justify-center">
        <el-button @click="goback" size="small">取消</el-button>
      </div>
    </div>
    <div v-if="isSHowPaper" class="h-full">
      <el-page-header @back="returnBack" content="试卷"></el-page-header>
      <AnswerSheet class="h-[calc(100%-32px)]" :id="currentRow.PaperId" />
    </div>
    <el-dialog :close-on-click-modal="false" title="查看" :visible.sync="showJoinExamDialogVisible" width="50%"
      class="small-dialog" v-dialogDrag :before-close="confirmAndCancel">
      <el-tabs v-model="activeNameTab" @tab-click="handleClick">
        <el-tab-pane label="已考" name="0" />
        <el-tab-pane label="未考" name="1" />
      </el-tabs>
      <ExamRecordCommon class="h-[calc(100%-54px)] flex flex-col" :studentList="attendStudentList"
        :departmentList="departmentList" :searchData="searchStatisticsData" :loading="loadingStatistics"
        :passList="passList" :isHasExamed="parseInt(activeNameTab)" :item="examSelectItem" @viewInfo="viewInfo"
        @searchList="searchAllList" @selectionChange="selectionChange" 
        @downloadGrades="downloadGrades" /> 
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button size="small" type="primary" icon="iconfont icon-save" @click="confirmAndCancel">确定</el-button>
        <el-button size="small" icon="iconfont icon-close" @click="confirmAndCancel">取消</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import DiyService from '@/modules/educational-training-management-sm/services/DiyService'
import dayjs from 'dayjs'
import { OrganizationApi } from '@wiz-api/account'
import { isEmpty, map } from 'lodash'
import { mapGetters } from 'vuex'
import AnswerSheet from './AnswerSheet'
import ExamRecordCommon from './ExamRecordCommon'

const organizationApi = new OrganizationApi()

export default {
  name: 'exam-record-info',
  components: {
    AnswerSheet,
    ExamRecordCommon,
  },
  computed: {
    ...mapGetters({ currentTheme: 'System/currentTheme' }),
  },
  props: {
    operateType: {
      default: '',
      type: String,
    },
    operateData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      isShowDialog: false,
      showJoinExamDialogVisible: false,
      activeNameTab: '0',
      examNum: 0,
      typeLoading: false,
      examSelectItem: {},
      percentage: 0,
      joinOption: {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)',
        },
        color: ['#68bbc4', '#5087ec'],
        grid: {
          bottom: 4,
        },
        series: [
          {
            type: 'pie',
            radius: ['30%', '70%'],
            data: [],
            center: ['50%', '50%'],
            avoidLabelOverlap: true,
            labelLayout: 'force',
            labelLine: {
              show: true,
            },
            label: {
              show: true,
              formatter: '{b}: {c} ({d}%)',
            },
          },
        ],
      },
      selection: [],
      activeNames: '',
      departmentList: [], // 所属部门下拉框数据
      searchData: {
        DeptId: '',
        ExamineeName: '',
        IsPass: null,
      },
      tableParams: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      searchStatisticsData: {
        ExamineeName: '',
        DeptId: '',
        IsPass: null,
      },
      dataList: [],
      studentList: [],
      passList: [
        { label: '是', value: 1 },
        { label: '否', value: 0 },
      ],
      isSHowPaper: false,
      loading: false,
      loadingStatistics: false,
      loadPaper: false,
      renderData: [],
      paperList: [],
      currentIndex: 0,
      originData: {} ,
      title: '',
      currentRow: {} ,
      attendStudentList: [] ,
      exportTimer: null,
    }
  },
  watch: {} ,
  created() { } ,
  async mounted() {
    this.initStatisData()
  },

  methods: {
    returnBack() {
      this.isSHowPaper = false
      if (this.isShowDialog) {
        this.showJoinExamDialogVisible = true
      }
    },
    searchAllList() {
      if (this.activeNameTab === '0') {
        this.searchList()
      } else {
        this.searchNotJoinList()
      }
    },
    handleClick() {
      this.clearSearchData()
      this.attendStudentList = []
      if (this.activeNameTab === '0') {
        this.searchList()
      } else {
        this.searchNotJoinList()
      }
    },
    showJoinExamDialog() {
      this.showJoinExamDialogVisible = true
      this.isShowDialog = true
      this.handleClick()
    },
    clearSearchData() {
      this.searchStatisticsData = this.$options.data().searchStatisticsData
    },
    confirmAndCancel() {
      this.showJoinExamDialogVisible = false
      this.isShowDialog = false
      this.clearSearchData()
    },
    async initStatisData() {       
      this.getPersonCountAndJoinSituation()
      this.getDepartmentList()
      this.getGradeRate()
      this.searchList()
    },
    async getPersonCountAndJoinSituation() {
      const params = {
        ApiEngineKey: 'total_examinee',
        PlanId: this.$route.query.id,
      }
      const [err, res] = await DiyService.getInterfaceList(params)
      if (!err && res.Code === 1) {
        this.examNum = res.Data.reduce((pre, cur) => {
          return pre + cur.Count
        }, 0)
        switch (res.Data.length) {
          case 0:
            this.joinOption.series[0].data = [{
              value: 0,
              name: '未参加',
            }, {
              value: 0,
              name: '已参加', 
            }]
            break
          case 1:
            this.joinOption.series[0].data = [
              {
                value: res.Data[0].Count,
                name: res.Data[0].GroupName,
              },
              {
                value: 0,
                name: res.Data[0].GroupName === '未参加' ? '已参加' : '未参加',
              },
            ]
            break
          case 2:
            this.joinOption.series[0].data = [
              {
                value: res.Data[0].Count,
                name: res.Data[0].GroupName,
              },
              {
                value: res.Data[1].Count,
                name: res.Data[1].GroupName,
              },
            ]
            break
          default:
            break
        }
      }
    },
    async getGradeRate() {
      const [err, res] = await DiyService.getInterfaceList({
        ApiEngineKey: 'get_exam_pass_rate',
        PlanId: this.$route.query.id,
      })
      if (!err && res.Code === 1) {
        this.percentage = Number(res.Data)*100
      }
    },
    selectionChange(selection) {
      this.selection = map(selection, 'TaskId')
    },
    /**
     * @description 部门列表查询
     */
     async getDepartmentList() {
      this.departmentLoading = true
      const [err, res] = await organizationApi.getList({
        sorting: '', // 排序
        skipCount: 0,
        maxResultCount: 999,
      })
      this.departmentLoading = false
      if (!err) {
        this.departmentList = res.items
      }
    },
    // 下载成绩单
    async downloadGrades() {
      if (this.exportTimer) {
        return
      }

      if (!this.selection || this.selection.length === 0) {
        this.$message.warning('请选择要导出的数据')
        return
      }

      this.loading = true
      this.exportTimer = setTimeout(() => {
        this.exportTimer = null
      }, 1000)

      try {
        const params = {
          ApiEngineKey: 'export_exam_plan_score_list',
          PlanId: this.$route.query.id,
          ...this.searchStatisticsData,
          IdList: this.selection.join(','),
        }
        const res = await DiyService.getInterfaceList(params)
        if (res[1].Code === 1) {
          if (!res[1].Data?.FileByteBase64) {
            this.$message.error('导出数据格式错误')
            return
          }
          try {
            const binaryString = window.atob(res[1].Data.FileByteBase64)
            const bytes = new Uint8Array(binaryString.length)
            for (let i = 0; i < binaryString.length; i++) {
              bytes[i] = binaryString.charCodeAt(i)
            }
            const blob = new Blob([bytes], { 
              type: res[1].Data.ContentType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = res[1].Data.FileName || `考试成绩单${dayjs().format('YYYY-MM-DD')}.xlsx`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          } catch (decodeError) {
            this.$message.error('文件解码失败')
          }
        } else {
          this.$message.error(res[1].Msg || '导出失败')
        }
      } catch (error) {
        this.$message.error('导出失败')
      } finally {
        this.loading = false
      }
    },
    // 打开试卷
    async viewInfo(row) {
      this.showJoinExamDialogVisible = false
      this.currentRow = row
      this.isSHowPaper = true
    },
    goback() {
      const url = Wiz?.globalSettings?.globalConfig?.routerBase
        ? `/${Wiz.globalSettings.globalConfig.routerBase}/educational-training-management-sm/exam-manage-construction-unit/exam-plan`
        : '/educational-training-management-sm/exam-manage-construction-unit/exam-plan'
      this.$router.push(url)
    },
    // 学生未参加
    async searchNotJoinList() {
      this.loadingStatistics = true
      const [err, res] = await DiyService.getInterfaceList({
        ApiEngineKey: 'get_exam_plan_unattend_list',
        PlanId: this.$route.query.id
      })

      this.loadingStatistics = false
      if (!err && res.Code === 1) {
        this.attendStudentList = res.Data
        // this.tableParams.total = res.DataCount
      } else {
        this.$message.error(res.Msg)
      }
    },

    // 学生成绩列表
    async searchList() {
      let err
      let res
      if (this.showJoinExamDialogVisible) {
        this.loadingStatistics = true
      } else {
        this.loading = true
      }

      if (this.showJoinExamDialogVisible) {
        ;[err, res] = await DiyService.getInterfaceList({
          ApiEngineKey: 'get_exam_plan_score_list',
          PlanId: this.$route.query.id,
          ...this.searchData,
          PageSize: this.tableParams.pageSize,
          PageIndex: this.tableParams.pageIndex,
        })
        if (!err) {
          this.attendStudentList = res.Data
          // this.tableParams.total = res.DataCount
        } else {
          this.$message.error(res.Msg)
        }
      } else {
        ;[err, res] = await DiyService.getInterfaceList({
          ApiEngineKey: 'get_exam_plan_score_list',
          PlanId: this.$route.query.id,
          ...this.searchData,
          PageSize: this.tableParams.pageSize,
          PageIndex: this.tableParams.pageIndex,
        })
        if (!err && res.Code === 1) {
          this.studentList = res.Data
          this.tableParams.total = res.DataCount
        }else {
          this.$message.error(res.Msg)
        }
      }
      this.loadingStatistics = false
      this.loading = false
    },
    handleSizeChange(val) {
      this.tableParams.pageSize = val
      this.searchList()
    },
    handleCurrentChange(val) {
      this.tableParams.pageIndex = val
      this.searchList()
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
